import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Output,
    input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'voice-call-button',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule],
    templateUrl: './voice-call-button.component.html',
    styleUrl: './voice-call-button.component.scss',
})
export class VoiceCallButtonComponent {
    @Output() buttonClicked = new EventEmitter<string>();

    icon = input<string>('');
    iconSelected = input<string>('');
    title = input<string>('');
    titleSelected = input<string>('');
    isClickedInput = input<boolean | undefined>(false);
    disabled = input<boolean>(false);

    onButtonClick(): void {
        this.buttonClicked.emit(
            this.isClickedInput() ? this.titleSelected() : this.title(),
        );
    }
}
